/** @jsx jsx */
import { Flex as IrisFlex } from "@eworkit/iris";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { Badge } from "@/components/Badge";
import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { Flex } from "@/eworkitComponents";

import "./_workstyle.scss";

interface ISingleWorkStyleEditProps {
  type: string;
  score: number;
  WorkstyleIcon: any;
}

const COLOR_MAP = ["n200", "n300", "n500", "n700", "vg700", "vg600", "vg500"];

/**
 * @deprecated Use iris-based SingleWorkStyle implementation instead.
 */
export const SingleWorkStyle: FunctionComponent<ISingleWorkStyleEditProps> = ({ type, score, WorkstyleIcon }) => {
  const { t } = useTranslation("session");

  return (
    <Section shadow="none" borderRadius border={[true, true, true, true]} key={type}>
      <Flex padding={["sm"]} innerPadding="sm" direction="row" align="center" justify="space-between">
        <IrisFlex
          alignItems="center"
          justifyContent="center"
          sx={{ bg: COLOR_MAP[score], width: "32px", height: "32px", borderRadius: "4px" }}>
          <WorkstyleIcon size="sm" color="n0" />
        </IrisFlex>
        <Flex grow={1}>
          <Header size="xs">{t(`CONSULTANT_PROFILES.DETAIL.WORK_STYLES.TYPES.${type}.HEADER`)}</Header>
        </Flex>
        <Flex>
          <Badge
            borderRadius="4px"
            backgroundColor="background-card-bottom"
            color="grey1"
            borderColor="background-card-bottom"
            contentMargin={[false, "md"]}>
            {t(`CONSULTANT_PROFILES.DETAIL.WORK_STYLES.POINTS`, { count: score })}
          </Badge>
        </Flex>
      </Flex>
    </Section>
  );
};
